export default "__VITE_ASSET__CbkF3_Z$__"